import { render, staticRenderFns } from "./Arrecadacao.vue?vue&type=template&id=5f1da402&scoped=true&"
import script from "./Arrecadacao.vue?vue&type=script&lang=js&"
export * from "./Arrecadacao.vue?vue&type=script&lang=js&"
import style0 from "./Arrecadacao.vue?vue&type=style&index=0&id=5f1da402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1da402",
  null
  
)

export default component.exports